import {
  CLEAR_UNFINALIZED_PRESCRIPTION,
  CLEAR_HISTORY_PRESCRIPTION,
  NEW_PRESCRIPTION_RECEIVED,
  ORDERED_PRESCRIPTION_RECEIVED,
  PRACTITIONER_HISTORY_PRESCRIPTION_RECEIVED,
  PRACTITIONER_PRESCRIPTION_HISTORY_RECEIVED,
  PRACTITIONER_UNFINALIZED_PRESCRIPTION_RECEIVED,
  PRESCRIPTION_HISTORY_RECEIVED,
  PRESCRIPTION_PAGE_TAB_SHOW_ITEM_LIST,
  REFILL_REQUEST_RECEIVED,
  UNFINALIZED_PRESCRIPTIONI_ID_RECEIVED,
  UNORDERED_PRESCRIPTION_RECEIVED,
} from "../constants/types/prescriptionType";

const initialState = {
  newPrescriptions: [],
  prescriptionHistory: [],
  refillRequests: [],
  practitionerPrescriptionHistory: [],
  orderedPrescription: [],
  unorderedPrescription: [],
  practitionerHistoryPresctionDetail: [],
  practitionerUnfinalizedPrescriptionDetail: [],
  unfinalizedPrescriptionId: 0,
  prescriptionPageTabShowItemList: [1],
};

export const prescriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_PRESCRIPTION_RECEIVED: {
      return {
        ...state,
        newPrescriptions: action.payload,
      };
    }
    case PRESCRIPTION_PAGE_TAB_SHOW_ITEM_LIST: {
      return {
        ...state,
        prescriptionPageTabShowItemList: action.payload,
      };
    }
    case CLEAR_UNFINALIZED_PRESCRIPTION: {
      return {
        ...state,
        practitionerUnfinalizedPrescriptionDetail: [],
      };
    }
    case CLEAR_HISTORY_PRESCRIPTION: {
      return {
        ...state,
        practitionerHistoryPresctionDetail: [],
      };
    }
    case PRESCRIPTION_HISTORY_RECEIVED: {
      return {
        ...state,
        prescriptionHistory: action.payload,
      };
    }
    case REFILL_REQUEST_RECEIVED: {
      return {
        ...state,
        refillRequests: action.payload,
      };
    }
    case PRACTITIONER_PRESCRIPTION_HISTORY_RECEIVED: {
      return {
        ...state,
        practitionerPrescriptionHistory: action.payload,
      };
    }
    case ORDERED_PRESCRIPTION_RECEIVED: {
      return {
        ...state,
        orderedPrescription: action.payload,
      };
    }
    case UNORDERED_PRESCRIPTION_RECEIVED: {
      return {
        ...state,
        unorderedPrescription: action.payload,
      };
    }
    case PRACTITIONER_HISTORY_PRESCRIPTION_RECEIVED: {
      return {
        ...state,
        practitionerHistoryPresctionDetail: action.payload,
      };
    }
    case PRACTITIONER_UNFINALIZED_PRESCRIPTION_RECEIVED: {
      return {
        ...state,
        practitionerUnfinalizedPrescriptionDetail: action.payload,
      };
    }
    case UNFINALIZED_PRESCRIPTIONI_ID_RECEIVED: {
      return {
        ...state,
        unfinalizedPrescriptionId: action.payload,
      };
    }
    default:
      return state;
  }
};
